import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './../spzaComponent';
import { getPowerBIEmbedParams, getPowerBIEmbedReportURL } from '../../utils/fieldHubUtils';
export class FieldHubModal extends SpzaComponent {
    componentDidMount() {
        const reportData = getPowerBIEmbedParams(this.props.iframeProps.reportName);
        const groupId = reportData.groupId;
        const reportId = reportData.reportId;
        const embedUrl = getPowerBIEmbedReportURL(groupId, reportId);
        // Refresh the access token if it has expired or about to expire
        this.props.getReportEmbedToken(reportData).then((token)=>{
            if (token) {
                const sectionId = reportData.sectionId;
                let config = {
                    type: 'report',
                    accessToken: token,
                    embedUrl: embedUrl,
                    id: reportId,
                    settings: {
                        filterPaneEnabled: false
                    },
                    pageName: sectionId
                };
                let reportContainer = document.getElementById('reportContainer');
                if (reportContainer && window && window['powerbi']) {
                    window['powerbi'].embed(reportContainer, config);
                }
            }
        });
    }
    renderImpl() {
        return /*#__PURE__*/ _jsx("div", {
            role: "dialog",
            "aria-label": "field hub is now open",
            className: "fieldHubModalClass",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "dialogContent",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "toolBar",
                        children: /*#__PURE__*/ _jsx("button", {
                            id: "cancelButton",
                            "aria-label": "close",
                            className: "cancel",
                            onClick: this.props.dismissModal,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "c-glyph"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "iframeContainer",
                        id: "reportContainer"
                    })
                ]
            })
        });
    }
}
FieldHubModal.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func
};
